import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";
import userCircleIcon from "assets/img/icons/user-single-icon.svg";
import userCircleWhiteIcon from "assets/img/icons/user-single-icon-white.svg";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import blockIcon from "assets/img/icons/icons8-unavailable.svg";

const MailingListList = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const ListTable = styled.table`
  width: 100%;
  min-width: 560px;
  max-width: 700px;

  border-spacing: 4px;
`;

const TableHead = styled.thead``;

const Label = styled.th`
  padding-bottom: 12px;
  max-width: ${(props) => (props.width ? props.width : "none")};

  font-size: 18px;
  font-weight: 400;
  text-align: left;
`;

const LabelWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const LabelWithIconIcon = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
`;

const LabelWithIconText = styled.div``;

const TableBody = styled.tbody``;

const Cell = styled.td`
  padding-left: ${(props) => (props.paddingleft ? props.paddingleft : "0")};
`;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};

  @media (max-width: ${globalConstants.switchTablet}) {
    margin-top: 6px;
    margin-bottom: ${css.VERTICAL_BOX_MARGIN};
  }
`;

const NoResults = styled.div`
  width: 100%;
  margin-top: 60px;
  margin-bottom: 60px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NoResultsIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const NoResultsText = styled.div`
  text-align: center;
`;

const PagesBadgeWrap = styled.div`
  display: flex;
`;

const PagesBadge = styled.div`
  height: 20px;
  padding: 0 14px 1px;

  font-size: 13px;
  color: #fff;
  white-space: nowrap;

  border-radius: 10px;
  background: ${(props) => (props.green ? css.BRAND_GREEN : css.NEGATIVE_RED)};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ({ data, limit, page, paginate, openPage, onOpenClick }) => {
  const numOfResults = data.mailingListListData.numOfResults;

  const list = data.mailingListListData.lists.map((mailingList) => {
    const { list, allLeads, verifiedLeads, pages } = mailingList;

    return (
      <tr key={list.id}>
        <Cell>{list.name}</Cell>
        <Cell paddingleft="3px">{allLeads}</Cell>
        <Cell paddingleft="3px">{verifiedLeads}</Cell>
        <Cell>
          <PagesBadgeWrap>
            <PagesBadge green={pages > 0 ? 1 : 0}>{pages}</PagesBadge>
          </PagesBadgeWrap>
        </Cell>
        <Cell>
          <ButtonPrimarySmall onClick={() => onOpenClick(list.id)}>
            Open List
          </ButtonPrimarySmall>
        </Cell>
      </tr>
    );
  });

  // prepare pagination
  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  return (
    <MailingListList>
      <TableWrap className="table-wrap">
        {list.length > 0 && (
          <ListTable>
            <TableHead>
              <tr>
                <Label width="160px">Name</Label>
                <Label width="110px">
                  <LabelWithIcon>
                    <LabelWithIconIcon>
                      <img src={userCircleIcon} style={{ width: "100%" }} />
                    </LabelWithIconIcon>
                    <LabelWithIconText>Leads</LabelWithIconText>
                  </LabelWithIcon>
                </Label>
                <Label width="110px">
                  <LabelWithIcon>
                    <LabelWithIconIcon>
                      <img
                        src={userCircleWhiteIcon}
                        style={{ width: "100%" }}
                      />
                    </LabelWithIconIcon>
                    <LabelWithIconText>Verified</LabelWithIconText>
                  </LabelWithIcon>
                </Label>
                <Label width="100px">Pages</Label>
                <Label width="100px"></Label>
              </tr>
            </TableHead>
            <TableBody>{list}</TableBody>
          </ListTable>
        )}
        {list.length === 0 && (
          <NoResults>
            <NoResultsIcon>
              <img src={blockIcon} style={{ width: "100%" }} />
            </NoResultsIcon>
            <NoResultsText>
              You don't have any Mailing List yet. Your first list will be
              created automatically with your first Landing Page, or you can
              create one yourself now.
            </NoResultsText>
          </NoResults>
        )}
      </TableWrap>
      {showPagination && (
        <Pagination>
          {page > 1 && (
            <ButtonRoundIcon
              icon={leftIcon}
              hoverIcon={leftWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("previous")}
            />
          )}
          {page < maxPage && (
            <ButtonRoundIcon
              icon={rightIcon}
              hoverIcon={rightWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("next")}
            />
          )}
        </Pagination>
      )}
    </MailingListList>
  );
};
